
import React from 'react';
import Recherche from './Recherche'
import Apsam from '../images/general/Apsam.png'
import '../fichierCss/Entete.css'

const Entete = () => {
    return (
        <div className="entete-wrapper">
            <div className="entete-gauche">
                <img src={Apsam} className="entete-logo" alt="Logo APSAM" />
                <div className="entete-titre">
                    <div>Association</div>
                    <div style={{ paddingLeft: '0.5em' }}>Pour la Promotion</div>
                    <div style={{ paddingLeft: '1em' }}>Des Sages-femmes</div>
                    <div style={{ paddingLeft: '0.5em' }}>et Maieuticiens</div>
                    <div>du Burkina</div>
                </div>
            </div>
            <div className="entete-droite">
                <Recherche />
            </div>
        </div>
    );
}
export default Entete;
